var apiRoot = 'https://api.' + (window.homeasapTest ? 'test' : '') + 'homeasap.com/NPlay.Services.NPlayApi/api/';

const urlParams = new URLSearchParams(location.search);
let mlsQueryString = urlParams.get('mlsid');
let storedMls = window.localStorage.getItem('hamlsid');
let mlsId = mlsQueryString || storedMls;
let mlsBar = document.getElementById('mls-bar');
let guid = urlParams.get('guid') || urlParams.get('token');

populateMLS();
updateCheckoutButtons();
storeMLS();

function populateMLS() {
  // Try pulling MLS from previous page if other sources not available
  if ( !mlsId && !storedMls && (document.referrer || '').indexOf('mlsid') > -1 ) {
    let lastPageParams = new URLSearchParams(document.referrer);
    mlsId = lastPageParams.get('mlsid');
  }

  // If MLS is available, display MLS banner
  if ( mlsId && mlsBar ) {
      mlsBar.style.display = 'block';
  }

  // Populate MLS name on page
  if ( mlsId ) {
    window.jQuery.ajax({
      url: apiRoot + "mls/" + mlsId,
      type: "GET",
      dataType: 'json',
      crossDomain: true,
      success: function(data) {
        if (data && data.Name) {
          var mlsName = data.Name;
          window.jQuery('.mls-name').text(mlsName);
          
          // Reroute to READ if MLS has pass through fees for alternate pricing
          if (data.HasSetupPassFees) {
            window.jQuery('#checkout').hide();
            console.log('Home ASAP: Checkout hidden due to special MLS pricing.');
            window.jQuery('.idx-buy-button a').attr('href', 'https://sacontrolpanel.homeasap.com/idx/step_plan');
            window.jQuery('.idx-buy-button').attr('href', 'https://sacontrolpanel.homeasap.com/idx/step_plan');
            console.log('Home ASAP: Buttons rerouted to READ due to special MLS pricing.');
          }
        }
      },

      error: function(jqXHR, status, thrownError) {
        
      }
    });
  }
}

function updateCheckoutButtons() {
  let checkoutBtn = jQuery('.mls-checkout-button');

  if (checkoutBtn.length > 0) {
    if (! guid ) {
      for (let i = 0; i < checkoutBtn.length; i++) {
        checkoutBtn[i].href = checkoutBtn[i].href + '?mlsid=' + mlsId;
      }
    } else {
      for (let i = 0; i < checkoutBtn.length; i++) { 
        checkoutBtn[i].href = checkoutBtn[i].href + '?mlsid=' + mlsId + '&guid=' + guid;
      }
    }
  }
}

function storeMLS() {
  if (mlsQueryString) {
    window.localStorage.setItem('hamlsid', mlsId);
  }
}
